import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const getMotivosCancelacion = async (filters) => {
  try {
    const response = await mainAxios.post(
      `/v1/motivos_cancelacion/by_filters`,
      filters,
      getDefaultHeaders()
    );

    return response.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
